require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./brand-design-literacy-for-all.json") })
        }
      }, "path---brand-design-literacy-for-all");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---brand-design-literacy-for-all!./.cache/json/brand-design-literacy-for-all.json
// module id = 376
// module chunks = 231608221292675